// ./client/src/components/Messages/MessageLog.js
import React, { useState, useEffect } from "react";
import { useAppContext } from "../../context/appContext";
import { Display, Display1 } from "../workspace";

const dateFormat = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

function SmsLog({ jobId }) {
  const { isLoading, authFetch, lists } = useAppContext();
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);

  const getDate = (date) => new Date(date).toLocaleString("en-US", dateFormat);

  const loadMessages = async () => {
    const { data } = await authFetch(jobId ? `/messages/job/${jobId}` : "/messages/recent");
    setMessages(data.messages || []);
    setSelected(null);
  };

  useEffect(() => {
    loadMessages();
  }, []);

  const getJobNumber = (jobId) => {
    return lists?.allJobs.filter(
      (job) => String(job.id) === String(jobId)
    )[0]?.job_number;
  };

  const statusColor = (status) =>
    status === "Delivered" || status === "Sent" ? "text-green" : "text-red";

  return (
    <div className="group whole">
      <form className="form" onSubmit={(e) => e.preventDefault()}>
        <h3>Recent Text Messages</h3>
        <div className="form-center">
          <button className="btn" type="button" onClick={loadMessages} disabled={isLoading}>
            Refresh Log
          </button>
        </div>
        {/* --- selected message details --- */}
        {selected && (
          <>
            <div className="form-center">
              <div className="one-half">
                <Display name="Sent At" value={getDate(selected.created_at)} />
                <Display name="From" value={selected.from_contact} />
                <Display name="To" value={selected.to_contact} />
              </div>
              <div className="oneone-half">
                <Display name="Message ID" value={selected.message_id} />
                <Display name="Job Number" value={getJobNumber(selected?.job_id)} />
                {selected.subject && <Display name="Subject" value={selected.subject} />}
              </div>
            </div>
            
            <div className="form-center">
              <div className="whole">
                <Display1
                  name="Message Body"
                  value={selected.body}
                  style={{ maxHeight: "12rem", overflow: "scroll" }}
                />
              </div>
              <div className="whole">
                {selected.error && (
                  <Display1
                    name="Error"
                    value={selected.error || "None"}
                    style={{
                      maxHeight: "12rem",
                      overflow: "scroll",
                      color: selected.error ? "red" : undefined,
                    }}
                  />
                )}
              </div>
            </div>
            <div className="form-center">
              {selected.status_details && (
                <div className="one-half">
                  <Display1
                    name="Status Details"
                    value={JSON.stringify(selected.status_details, null, 2)}
                    style={{
                      maxHeight: "12rem",
                      overflow: "scroll",
                      fontFamily: "monospace",
                    }}
                  />
                </div>
              )}
            </div>
          </>
        )}
        {/* --- messages table --- */}
        <div className="table whole admin-log">
          <table>
            <thead>
              <tr>
                <th style={{ width: 180 }}>Time</th>
                <th style={{ width: 110 }}>Status</th>
                <th style={{ width: 80 }}>Channel</th>
                <th style={{ width: 160 }}>To</th>
                <th style={{ width: 130 }}>Job Number</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((record) => (
                <tr
                  key={record.message_id || record.created_at}
                  className={selected?.message_id === record.message_id ? "selected" : ""}
                  onClick={() => setSelected(record)}
                >
                  <td>{getDate(record.created_at)}</td>
                  <td className={statusColor(record.status)}>{record.status}</td>
                  <td>{record.channel}</td>
                  <td>{record.to_contact}</td>
                  <td>{getJobNumber(record.job_id)}</td>
                  <td>
                    <div className="json-cell">{record.body}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
}

export default SmsLog;
